export const MESSAGE_USER_UPDATE_PROFILE_SUCCESS = '개인 정보를 수정했습니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/shared/user-message.ts